export default __webpack_public_path__ + "static/testing-strategy-3d10870b51932f00ede3a475b61ca613.png";